import './UnpaidInvoiceModal.scss';
import MhmLogoRedBackground from "../icons/MhmLogoRedBackground";
import {Button} from "../account/misc/Button";
import {logout} from "../../service/AuthService";
import {env} from "../../env/env";
import {openInNewTab} from "../../util/utils";
import {Spinner} from "../account/misc/Spinner";
import {useState} from "react";
import MembersApi from "../../api/MembersApi";

interface UnpaidInvoiceModalProps {
  url: string
}

export default function UnpaidInvoiceModal({url}: UnpaidInvoiceModalProps) {
  const [loading, setLoading] = useState(false);

  function signOut() {
    logout().then(() => {
      window.location.href = env.basePath;
    });
  }

  function finalize() {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === 'visible') {
        setLoading(true);
        MembersApi.getUnpaidInvoicePaymentPageUrl().then(resp => {
          if (!resp.data.invoice) {
            window.location.reload();
          }
          setLoading(false);
        });
      }
    });
    openInNewTab(url);
  }

  return <div className={'unpaid-invoice-modal'}>
    <div className={'content'}>
      {loading && <Spinner/>}
      {!loading && <>
        <span className={'title'}>Your credit card transaction is not complete.</span>
        <span className={'subtitle'}>Please click on the button below to finalize the credit card 3Ds authentication.</span>
        <div className={'buttons'}>
          <Button className={'finalize'} type={'Primary'} onClick={finalize}>Finalize payment</Button>
          <Button className={'sign-out'} onClick={signOut}>Sign out</Button>
        </div>
      </>}
    </div>
    <div className={'ftr'}><MhmLogoRedBackground/></div>
  </div>
}
